import React from "react";

import styles from "./InputLabel.module.scss";

interface Props {
  label: string;
  required: boolean;
}

function InputLabel(props: Props) {
  const { label, required } = props;

  const asterisk = <p className={styles.redAsterisk}> ※</p>;

  return (
    <div className={styles.container}>
      <p className={styles.labelText}>{label}</p>
      {required ? asterisk : null}
    </div>
  );
}

export default InputLabel;
